module.exports = __webpack_public_path__ + "static/img/10.255da2c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/3/10.jpg
// module id = G6W0
// module chunks = 1